// extracted by mini-css-extract-plugin
export default {"toggleWindowSize":"_1cYvUmrsVW-MgK0Eph2wyj","toggleLabel":"_1NMxAzjwZKEYtrpPVpR_ti"};